import type { PageGuide } from "../page-guide.js";

/**
 * Help guide for My vault — personal workspaces owned by the signed-in user
 * (ADR-0106). Distinct from Documents → Working (shared) and Partner vaults
 * (admin cross-partner lifecycle).
 */
export const myVaultGuide: PageGuide = {
  route: "/my-vault",
  version: 1,
  overviewArticleId: "my-vault-overview",
  steps: [
    {
      id: "pick-partner",
      title: "Pick a partner first",
      body: "Personal workspaces live **inside a partner vault**. Use the **Partner** selector so attach and upload hit the right tenant schema.",
    },
    {
      id: "create-personal",
      title: "Create a personal workspace",
      body: "Use **New personal workspace** to create one owned by you. Only you and administrators can see it — not role lists.",
    },
    {
      id: "attach-team-site",
      title: "Attach an existing Team site",
      body: "Under **Collaboration sites**, paste the URL of an existing SharePoint Team site. Insights does not auto-create M365 sites.",
    },
  ],
  panels: [],
  guidedActions: [],
};
